import { useCallback } from 'react';

import { Tooltip, POSITIONS } from '@hivebrite/design-system/Tooltip';

import { useQuillEditorContext } from 'hb-react/shared/components/DesignSystem/QuillEditor/contexts/QuillEditorContext';
import ToolbarItem from 'hb-react/shared/components/DesignSystem/QuillEditor/Toolbar/components/ToolbarItem';

const Icon = (props) => (
  <svg {...props} viewBox="0 0 467.765 467.765">
    <path
      fill="currentColor"
      d="M409.294 58.471V0H233.882v58.471h43.373L126.903 409.294H58.471v58.471h175.412v-58.471H190.51L340.861 58.471z"
    />
  </svg>
);

const Italic = ({ onItemClick, value, ...otherProps }) => {
  const { quillRef } = useQuillEditorContext();

  const handleToggleValue = useCallback(() => {
    quillRef.current.format('italic', !value, 'user');
    onItemClick();
  }, [value]);

  return (
    <Tooltip initialPosition={POSITIONS.BOTTOM} childrenElement={__('Italic')}>
      <ToolbarItem
        onClick={handleToggleValue}
        isActive
        icon={Icon}
        {...otherProps}
      />
    </Tooltip>
  );
};

Italic.getFormat = (format) => format?.italic;

export default Italic;
